import React from "react";
import { Jumbotron } from "./Jumbotron";
import { SectionKeys } from "./SectionKeys";
import { SectionCalculator } from "./SectionCalculator";
import { SectionSteps } from "./SectionSteps";
import { StartInvesting } from "./StartInvesting";
import { resource } from "@app/common/localization/resource";
import { useDocumentTitle } from "@app/common/hooks/useDocumentTitle";
import { Layout } from "@app/common/components/Layout";

export const LandingPage: React.VFC = () => {
  useDocumentTitle(resource("landing.htmlTitle"));

  return (
    <Layout invertHeader={true}>
      <main>
        <Jumbotron />
        <SectionKeys />
        <SectionCalculator />
        <SectionSteps />
        <StartInvesting />
      </main>
    </Layout>
  );
};
